<script setup lang="ts">
  import { useCart } from '@/composables/useCart'

  useHead({ title: 'cart' })
  const { loading, sortedCart, incompleteCart, completeCart, completeExpanded, toggleComplete, removeItem } = useCart()
</script>

<template>
  <div class="page--cart">
    <h1 class="page__heading">shopping cart</h1>

    <section v-if="loading" class="section">
      <p>Loading...</p>
    </section>

    <section v-else class="section">
      <p v-if="sortedCart.length === 0" class="my-10 italic">
        <i class="fad fa-dolly-empty" />
        your cart is empty
      </p>

      <template v-if="completeCart.length > 5">
        <DraggableCartSection v-model="incompleteCart" @toggle-complete="toggleComplete" @remove-item="removeItem" />
        <CartForm />
        <button
          class="text-juss-purple-400 flex items-center px-1 mt-4 mb-2 font-bold"
          @click="completeExpanded = !completeExpanded"
        >
          <i class="fas fa-chevron-up text-sm transition origin-center" :class="{ 'rotate-180': completeExpanded }" />
          <span class="ml-2.5 text-lg">{{ completeCart.length }} checked items</span>
        </button>
        <Transition name="slide-fade">
          <DraggableCartSection
            v-if="completeExpanded"
            v-model="completeCart"
            @toggle-complete="toggleComplete"
            @remove-item="removeItem"
          />
        </Transition>
      </template>

      <template v-else>
        <DraggableCartSection v-model="sortedCart" @toggle-complete="toggleComplete" @remove-item="removeItem" />
        <CartForm />
      </template>
    </section>
  </div>
</template>

<style lang="sass">
  .page--cart
    --page-max-width: 700px

    .page__heading
      font-size: 3em
      text-transform: lowercase
      margin-bottom: .2em

  .list-enter-active, .list-leave-active
    transition: 150ms ease-in-out
  .list-enter-from, .list-leave-to
    opacity: 0
    transform: translateY(-4px)

  .slide-fade-enter-active
    transition: 150ms ease-out
  .slide-fade-leave-active
    transition: 150ms cubic-bezier(1, 0.5, 0.8, 1)
  .slide-fade-enter-from, .slide-fade-leave-to
    transform: translateY(-0.5rem)
    opacity: 0
</style>
